import React from 'react'

const Syllabus = () => {
  return (
    <div>
      <h1>Syllabus Component</h1>
    </div>
  )
}

export default Syllabus
